/* ProductTileBehavior for Donna Karan */
/* Modified to attach to <ul class="product-tile-root"> instead of custom element */

class ProductTileBehavior {
  constructor(el) {
    this.el = el;
    this.masterSku = el.getAttribute('data-master-sku');
    this.tileObserver = null;
    this.init();
  }

  init() {
    window.masterSkus = window.masterSkus || [];
    this.watchViewport();
    // this.clickEventListener(); // Uncomment if needed
  }

  watchViewport() {
    const intersectOpt = { root: null, threshold: 0.4 };
    const handleIntersect = (entries, observer) => {
      entries.forEach(entry => {
        if (
          entry.isIntersecting &&
          entry.target.getAttribute('data-viewport-observed') !== 'true'
        ) {
          entry.target.setAttribute('data-viewport-observed', 'true');
          window.trigger('theme:producttile:viewed', [entry.target]);
          this.loadByMasterSku();
          observer.unobserve(entry.target);
          this.tileObserver = null;
        }
      });
    };
    this.tileObserver = new IntersectionObserver(handleIntersect, intersectOpt);
    this.tileObserver.observe(this.el);
  }

  loadByMasterSku() {
    if (this.masterSku && window.masterSkus.indexOf(this.masterSku) === -1) {
      window.masterSkus.push(this.masterSku);
      const fetchUrl = `${theme.urls.all_products_collection}/MasterSku:${this.masterSku}?view=data`;
      fetch(fetchUrl)
        .then(response => response.json())
        .then(data => {
          window.trigger(`theme:producttile:${this.masterSku}:variantsLoaded`, {
            products: data.products
          });
        });
    } else if (!this.masterSku) {
      console.log('~~~~~ NO MASTER SKU');
    }
  }

  /* Optional click handler — enable if needed
  clickEventListener() {
    const plinks = this.el.querySelectorAll('.product-tile--link');
    plinks.forEach(plink => {
      plink.addEventListener('click', e => {
        e.preventDefault();
        console.log('click.ProductTile', e);
      });
    });
  }
  */
}

// Attach behavior to all <ul class="product-tile-root"> on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('ul.product-tile-root').forEach(el => {
    new ProductTileBehavior(el);
  });
});